import { render, staticRenderFns } from "./vIngredientManagement.vue?vue&type=template&id=40191d02&scoped=true"
import script from "./vIngredientManagement.vue?vue&type=script&lang=ts"
export * from "./vIngredientManagement.vue?vue&type=script&lang=ts"
import style0 from "./vIngredientManagement.vue?vue&type=style&index=0&id=40191d02&prod&lang=css"
import style1 from "./vIngredientManagement.vue?vue&type=style&index=1&id=40191d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40191d02",
  null
  
)

export default component.exports